export const ADMIN_ROLE = 'ROLE_admin';
export const OWNER_ROLE = 'ROLE_administrator';
export const BACKSPACE_KEY = 'Backspace';
export const DELETE_KEY = 'Delete';
export const REQUIRED_KEY = 'Requerido';
export const NULL_OPTION_SELECT = Object.freeze({ label: '', value: '' });
export const QUOTE_MARK = '"';
export const COLUMN_SEPARATOR = '-';
export const SPACE_KEY = ' ';
export const MEDIUM_COMPONENT_SIZE = 'md';
export const MEDIUM_FULL_COMPONENT_SIZE = 'md-full';
export const SMALL_COMPONENT_SIZE = 'sm';
export const EMPTY_FILE_SIZE = 0;
export const MB = 1048576;
export const MAX_CHAR_FILENAME_SM = 26;
export const MAX_CHAR_FILENAME_MD = 56;
export const MAX_WIDTH = 1365;
export const MAX_WIDTH_IMAGES = 456;
export const MIN_WIDTH_IMAGES = 328;
const mimeTypesMap = {
  csv: 'text/csv',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  gif: 'image/gif',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  pdf: 'application/pdf',
  png: 'image/png',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};
export const MIME_TYPES_MAP = Object.freeze(mimeTypesMap);

export const STEP_STATE = {
  DISABLED: 'disabled',
  ACTIVE: 'active',
  COMPLETED: 'completed',
};

export const STEP_TYPE = {
  FIRST: 'first',
  PROGRESS: 'progress',
  LAST: 'last',
};
export const PROGRESS_STATE = {
  DEFAULT: 0,
  INITIATED: 0.0001,
  COMPLETED: 1,
};

export const NO_INFO = {
  text: 'No Info',
  timeFull: '?-?-? ?:?:?',
  timeUTC: '?-?-?T?:?:?Z',
  timeMonth: '?-?-?',
};

export const catchExceptionForTimeFull = {
  null: NO_INFO.timeFull,
  undefined: NO_INFO.timeFull,
  NaN: NO_INFO.timeFull,
  '': NO_INFO.timeFull,
};

export const catchExceptionForTimeMonth = {
  null: NO_INFO.timeMonth,
  undefined: NO_INFO.timeMonth,
  NaN: NO_INFO.timeMonth,
  '': NO_INFO.timeMonth,
};

export const catchExceptionForText = {
  null: NO_INFO.text,
  undefined: NO_INFO.text,
  NaN: NO_INFO.text,
  '': NO_INFO.text,
};
